importProgressBar.$inject = ['$timeout'];

/**
* @ngdoc    directive
* @name     importProgressBar
* @memberof csm.ui.importForm
* @restrict E
*
* @description
* Wrapper for the uibProgressBar directive. Used in the `importForm` template
* to create progress bars for the scopes created by `uploadBar` directives.
* 
* This directive will be bound to one of those objects and adds an update
* method with is a pass-through to this scope's digest so ui updating can
* be optimized per progress bar.
* 
* @attr {object}  barModel    Bar scope object reference
*******************************************************************************/
/* @ngInject */
export function importProgressBar($timeout) {
  return {
    restrict: 'E',
    require: '^^importForm',
    scope: { bar: '=barModel' },
    template:
      '<uib-progressbar class="progress-striped active" max="bar.max" value="bar.value" type="info">' +
      '<span style="color:white; white-space:nowrap; font-weight:bold"> {{ getDisplay() }}</span>' +
      '</uib-progressbar>',
    link: function (scope, elem, attr) {
      /** Get the bar model scope. */
      function getBar() {
        return scope.bar;
      }

      /** Add update function to bar scope to trigger a digest on this scope. */
      getBar().update = function () {
        $timeout();
      };

      /** Returns the display text to display on the progress bar. */
      scope.getDisplay = function () {
        return getBar().percentValue
          ? '{0}%'.format(getBar().value)
          : '{0} / {1}'.format(getBar().value, getBar().max);
      };
    }
  };
}
